export const AUTHENTICATION__API = {
  AUTHLOGIN: "/auth/login",
  AUTHLOGOUT: "/auth/logout",
  CHECK_SESSION: "/auth/check-session",
  FORCELOGOUT: "/auth/force-logout",
};

export const ADMINNOTIFICATION__API = {
  ADMINGETNOTIFICATION: "/get-notifications",
  ADMINCREATENOTIFICATION: "/create-notification",
  ADMINUPDATENOTIFICATION: "/update-notification",
  ADMINMARKASREADNOTIFICATION: "/markasread-notifications",
  ADDCLIENTNOTIFICATION: "/create-client-notification",
};

export const REGISTEREDUSER__API = {
  REGISTEREDUSER: "/accounts/registered-users",
  UPDATEIBSTATUS: "/accounts/change-ib-status",
  DASHBOARDREGISTEREDUSERS: "/dashboard-registered-users",
  DASHBOARDTOTALUSERS: "/get-dashboard-total-users",
  ALLREGISTEREDUSERUSER: "/get-allregister-users-csv",
};

// inactive and low balance accounts api
export const INACTIVEACCOUNTS__API = {
  INACTIVEACCOUNTS: "/accounts/inactive-accounts",
  INACTIVEACCOUNTDISABLE: "/disable-inactive-account",
};
export const LOWBALANCEACCOUNTS__API = {
  LOWBALANCEACCOUNTS: "/accounts/low-balance-accounts",
  LOWBALANCEACCOUNTDISABLE: "/disable-low-balance-account",
};

export const COMPANYINFO__API = {
  COMPANYINFO: "/generalinformation",
  LOGINPAGEINFO: "/login-page-info",
};

export const COUNTRIES__API = {
  COUNTRIES: "/countries",
};

export const CITIES__API = {
  CITIES: "/cities",
};
export const ALLNEWUSER__API = {
  INSERTNEWUSER: "/insert-new-user",
  REMOVENEWUSER: "/remove-new-user",
  GETALLPARTNERS: "/get-all-partner-users",
  GETALLCLIENTS: "/get-all-client-users",
};

export const STATES__API = {
  STATES: "/states",
};

export const PARTNERPAYMENTMETHOD__API = {
  PARTNER_PAYMENT_METHODS: "/partner-payment-methods",
  CREATE_PARTNER_PAYMENT_METHOD: "/create-partner-payment-methods",
  EDIT_PARTNER_PAYMENT_METHOD: "/edit-payment-methods",
  DELETE_PARTNER_PAYMENT_METHOD: "/delete-payment-methods",
};

export const NEWUSER__API = {
  NEWUSER: "/accounts/create-user",
};

export const CLIENTS_DOCUMENTS__API = {
  CLIENTS_DOCUMENTS: "/accounts/all-clients-documents",
  UPLOAD_DOCUMENTS: "/accounts/doc/upload",
  VERIFYDOC: "/accounts/verify-doc",
};

export const PROFILE__API = {
  FETCHPROFILE: "/accounts/user-rofile",
  IDENTITYVERIFICATION: "/accounts/identity-verification",
  RESIDENCEVERIFICATION: "/accounts/residence-verification",
  FETCHDOCUMENTS: "/accounts/clientdocuments",
  UPLOADDOCUMENT: "/accounts/doc/upload",
  BUSINESSAMOUNT: "/get-total-business",
};

export const BLOCKEDUSER__API = {
  BLOCKEDUSER: "/accounts/blocked-accounts",
  UNBLOCKUSER: "/accounts/unblocked-account",
};

export const DEMOACCOUNTS__API = {
  DEMOACCOUNTS: "/accounts/demo-accounts",
};

export const TESTINGACCOUNTS__API = {
  TESTINGACCOUNTS: "/accounts/testing-accounts",
  CREATETESTINGACCOUNT: "/accounts/create-testing-accounts",
};

export const LIVEACCOUNTS__API = {
  LIVEACCOUNTS: "/accounts/live-accounts",
};

export const ACCOUNTTYPES__API = {
  ACCOUNTTYPES: "/accounts/account-types",
};

export const AGREEMENTS__API = {
  CREATEAGREEMENT: "/create-agreement",
  GETTRADINGAGREEMENTS: "/get-trading-agreements",
  GETCLIENTSAGREEMENTSHISTORIES: "/get-clients-agreements-histories",
  GETPARTNERSAGREEMENTSHISTORIES: "/get-partners-agreements-histories",
  UPDATECLIENTSAGREEMENTSTATUS: "/update-client-agreement-status",
  GETOTHERSAGREEMENTS: "/get-others-agreements",
  GETIBAGREEMENTS: "/get-ib-agreements",
  ACCEPTEDAGREEMENTS: "/agreements/user/accepted",
  NOTACCEPTEDAGREEMENTS: "/agreements/user/notaccepted",
};

export const USERLOGINACTIVITY__API = {
  USERLOGINACTIVITY: "/auth/login-activities",
};

export const MARKETTINGTOOLS__API = {
  BANNERCATEGORIES: "/banner-categories",
  BANNERSIZES: "/banner-sizes",
  BANNERS: "/banners",
  CREATEBANNER: "/new-banner",
  UPDATEBANNER: "/update-banner",
  DELETEBANNER: "/delete-banner",
  BANNERSIZECREATE: "/create-banner-size",
  BANNERSIZEUPDATE: "/update-banner-size",
  BANNERSIZEDELETE: "/delete-banner-size",
};

export const CURRENCY__API = {
  ACTIVECURRENCIES: "/get-active-currencies",
  UPDATECURRENCYSYMBOL: "/update-currency-symbol",
  ACTIVECURRENCYGROUPS: "/get-active-currency-groups",
  UPDATECURRENCYGROUP: "/update-currency-group",
  DELETEGROUP: "/delete-currency-group",
  CREATEGROUP: "/create-currency-group",
  CREATESYMBOL: "/create-currency-symbol",
  DELETECURRENCY: "/delete-currency-symbol",
  GETCURRECNCYUSDT: "/get-currency-usd-to-inr",
  UPDTECURRENCYUSDT: "/update-currency-usd-inr",
};

export const COMMISSIONSETTINGS__API = {
  COMMISSIONSETTINGS: "/commission-settings",
  CREATECOMMISSIONSETTINGS: "/create-commission-settings",
};

export const PARTNERWITHDRAW__API = {
  DASHBOARDPARTNERWITHDRAW: "/trx-dashboard-partner-withdraw-requests",
  PARTNERWITHDRAW: "/partner-withdraw-requests",
  CHANGESTATUS: "/change-withdraw-status",
  UPDATEWITHDRAW: "/update-withdraw-request",
  PARTNERWITHDRAWEXCEL: "/partner-withdraw-requests-excel",
};

export const LIVETRADES__API = {
  LIVETRADES: "/live-trades",
  DASHBOARDLIVETRADES: "/get-dashboard-live-trades",
  LIVETRADESCHARTDATA: "/live-trades-chartdata",
};

export const USERLIVETRADES__API = {
  USERLIVETRADES: "/user-live-trades",
};

export const CLOSEDTRADES__API = {
  CLOSEDTRADES: "/closed-trades",
  DASHBOARDCLOSEDTRADES: "/get-dashboard-closed-trades",
  CLOSEDTRADESCHARTDATA: "/closed-trades-chartdata",
};

export const SHORTDURATIONTRADES__API = {
  SHORTDURATIONTRADES: "/short-duration-trades",
  // DASHBOARDCLOSEDTRADES: "/get-dashboard-closed-trades",
};

export const USERCLOSEDTRADES__API = {
  USERCLOSEDTRADES: "/user-closed-trades",
};

export const TRANSACTIONS__API = {
  TRXSUMMARIES: "/trx-summaries",
  TRXSUMMARIESEXCEL: "/trx-summaries-excel",
  TRXDEPOSITS: "/trx-deposits",
  TRXWITHDRAWAL: "/trx-withdrawal",
  TRXCREDITIN: "/trx-credit-in",
  TRXCREDITOUT: "/trx-credit-out",
  TRXINTERNALTRANSFER: "/trx-internal-transfer",
  UPDATEDEPOSIT: "/update-deposit-request",
  TRXDASHBOARDDEPOSITS: "/trx-dashboard-deposits",
  TRXDASHBOARDWITHDRAWAL: "/trx-dashboard-withdrawal",
  TRXDASHBOARDINTERNALTRANSFER: "/dashboard-internal-transfer",
  TRXDEPOSITEXCEL: "/trx-deposits-excel",
  TRXWITHDRAWALEXCEL: "/trx-withdrawal-excel",
};

export const RMSSETTINGS__API = {
  RMSSETTINGS: "/rms-settings",
  RMSGRAPH: "/rms-graphs",
  PROFITREACHES: "/profit-reaches",
  AUTOCREDITBACK: "/auto-credit-back",
  UPDATEPROFITREACHES: "/update-profit-reaches",
  UPDATERMSSETTINGS: "/update-rms-settings",
};

export const NEWS__API = {
  GETNEWS: "/news",
  ADDNEWS: "/add-news",
  DELETENEWS: "/news",
  UPDATENEWS: "/update-news",
  NEWSCATEGORIES: "/news-categories",
  SINGLENEWS: "/single-news",
};

export const TICKETS__API = {
  MESSAGES: "/messages",
  REPLY: "/send-reply",
  TOGGLE_TICKET: "/toggle-ticket",
  DELETECOMMENT: "/delete-coment",
  UPDATECOMMENT: "/update-comment",
  MARKSEEN: "/tickets-seen",
};

export const MARKETINGDATA__API = {
  GETMARKETINGUSERS: "/marketing-users",
  FILEUPLOAD: "/upload-excel",
  SENDEMAIL: "/send-emails",
  GETALLEMAIL: "/get-all-emails",
  GETEMAILSBYCATEGORY: "/get-emails-by-category",
};

export const SERVERCONFIG__API = {
  SERVERCONFIG: "/get-server-config",
  UPDATESERVERCONFIG: "/update-server-config",
};

export const EMAILCONFIG__API = {
  EMAILCONFIG: "/get-email-config",
  UPDATEEMAILCONFIG: "/update-email-config",
};

export const LEVERAGE__API = {
  LEVERAGE: "/leverages",
  USERLEVERAGE: "/user-leverages",
  CREATELEVERAGE: "/create-leverage",
  DELETELEVERAGE: "/delete-leverage",
};

export const GENERALINFO__API = {
  GENERALINFO: "/generalinformation",
  UPDATEGENERALINFO: "/generalinformation",
  UPDATEGENERALINFOLOGO: "/generalinformation-logo"
};

export const ACCGROUPS__API = {
  ACCGROUPS: "/account-groups",
  USERACCGROUPS: "/user-account-groups",
  UPDATEUSERACCGROUPS: "/update-user-account-groups",
  CREATEACCGROUPS: "/create-account-group",
  DELETEACCGROUPS: "/delete-account-group",
  UPDATEACCGROUPS: "/update-account-group",
  GETCURRENCIESGROUP: "/currency-groups",
};

export const BROKERSBANK__API = {
  BROKERSBANK: "/create-bank",
  GETBROKERSBANK: "/get-banks",
  GETCURRENCIES: "/get-currencies",
  UPDATEBANK: "/update-bank",
};

export const CRYPTOADDRESS__API = {
  GETCRYPTOADDRESS: "/cryptoaddress",
  CREATECRYPTOADDRESS: "/create-cryptoaddress",
  UPDATECRYPTOADDRESS: "/update-cryptoaddress",
};

export const ADMINS__API = {
  CREATEPERMISSION: "/create-permission",
  GETADMINS: "/admins-list",
  GETADMIN: "/auth/get-admin",
  GETROLES: "/roles-countries",
  CREATEADMIN: "/create-admin",
  UPDATEADMIN: "/update-admin",
  DELETEADMIN: "/delete-admin",
  GETLOGINACTIVITIES: "/admin-login-activities",
  CHANGETHEME: "/upadte-theme",
  GETALLMODULES: "/get-all-modules",
};

export const REGISTERUSERDETAILS__API = {
  REGPERSONALINFO: "/reg-personal-info",
  ACCOUNTDESCENDANTS: "/accounts/descendants",
  UPDATEREGPERSONALINFO: "/update-reg-user-details",
  CLIENTDEPOSITS: "/client-deposits",
  CLIENTWITHDRAWS: "/client-withdraws",
  CLIENTINTTRXS: "/client-internaltrx",
  CLIENTCREDITINOUT: "/client-credit-in-out",
  CLIENTMT5ACCOUNTANDTYPES: "/get-acctypes-mt5accounts",
  CHANGECLIENTMT5ACCOUNTANDTYPES: "/change-mt5-accounttype",
  CHANGECLIENTLEVERAGE: "/change-user-leverage",
  CHANGECLIENTPASSWORD: "/change-mt5-password",
  CHANGECLIENTLOGINPASSWORD: "/change-client-password",
  CLIENTTRADINGACCOUNTS: "/client-trading-accounts",
  USERTRADINGACCOUNTS: "/user-trading-accounts",
  CREATECLIENTCREDITINOUT: "/create-client-credit-inout",
  CREATECLIENTINTX: "/create-client-intx",
  PAYMENTSYSTEMFORDEPOSIT: "/payment-system-for-deposit",
  PAYMENTSYSTEMFORWITHDRAW: "/payment-system-for-withdraw",
  CREATECLIENTDEPOSIT: "/create-client-deposit",
  CREATECLIENTWITHDRAW: "/create-client-withdraw",
  GETMANAGERS: "/get-managers",
  ASSIGNUSER: "/assign-managers",
  USERDEMOACCOUNTS: "/user-demo-trading-accounts",
  USERDOCUMENTS: "/user-verifications",
  BROKERSBANK: "/brokers-banks-info",
  CREATELIVEACCOUNT: "/create-client-live-account",
  CREATEDEMOACCOUNT: "/create-client-demo-account",
  UPDATEMT5ACCOUNT: "/update-mt5-account",
};

export const CLIENTBANKS__API = {
  CLIENTBANKS: "/client-banks",
  CLIENTCRYPTOS: "/client-cryptos",
  CREATECLIENTBANK: "/create-client-bank",
  CREATECLIENTCRYPTO: "/create-client-crypto",
};

export const MAM__API = {
  GETALLMAM: "/get-all-mam",
  GETALLPAMM: "/get-all-pamm",
  GETALLCOPYTRADE: "/get-all-copy-trade",
  GETALLINVESTORS: "/all-investors",
  GETMONTHLYTRADES: "/get-monthly-trades",
  GETWEEKLYTRADES: "/get-weekly-trades",
  GETTOPTRADESBYSYMBOL: "/get-top-trades-symbol",
  GETMANAGERPROFITLOSS: "/get-manager-profit-loss",
  GETMAMMANAGERSTATISTICS: "/get-mam-manager-statistics",
  GETMAMMANAGERINVESTORS: "/get-manager-investors",
  CHANGEINVESTORSTATUS: "/change-investor-status",
  CHANGEMANAGERSTATUS: "/change-manager-status",
  REMOVEINVESTOR: "/remove-investor",
  GETLIVEORDERS: "/get-manager-live-orders",
  GETREPORTS: "/get-reports-manager-investors",
  COMMISSIONSTAB: "/get-manager-commission",
  COMMISSIONSHISTORYTAB: "/get-manager-commission-history",
  UPDATEINVESTORCOMMISSION: "/approve-investor-commission",
};

export const TRADEMASTER__API = {
  GETALLMANAGER: "/get-all-manager",
  GETRADEMASTERINVESTORSTATISTICS: "/get-trademaster-investor-statistics",
  GETINVESTORCLIENTS: "/get-trademaster-investor-clients",
  CHANGEINVESTORSTATUS: "/trademaster-investor-status-change",
};

export const CONTEST__API = {
  GETCONTEST: "/get-contest",
  GETALLCONTEST: "/all-contests",
  GETALLUPCOMINGCONTEST: "/upcoming-contests",
  GETALLRUNNINGCONTEST: "/running-contests",
  GETALLFINISHEDCONTEST: "/finished-contests",
  GETALLCONTESTACCTYPES: "/all-contest-accounts",
  UPDATECONTEST: "/update-contest",
  VIEWFINISHEDCONTEST: "/get-finished-contest",
  VIEWRUNNINGCONTEST: "/get-running-contest",
  VIEWUPCOMINGCONTEST: "/get-upcoming-contest",
  APPROVEDPARTICIPANTS: "/get-approved-participants",
  PENDINGPARTICIPANTS: "/get-pending-participants",
  ALLUPCOMINGPARTICIPANTS: "/get-all-upcoming-participants",
  ALLRUNNINGPARTICIPANTS: "/get-all-running-participants",
  ALLFINISHEDPARTICIPANTS: "/get-all-finished-participants",
  UPDATECONTESTANTSTATUS: "/update-contestant-status",
  CREATECONTEST: "/create-contest",
};

export const COMMISSIONTREE__API = {
  GETCOMMISSIONSETTINGS: "/commission-settings",
  VIEWCOMMISSION: "/view-commission-settings/tree",
  SPLITTOTALCOMMISSION: "/split-total-commission",
  ADDCOMMISSIONSETTINGSCONFIG: "/configuration/add-commission-settings/tree",
  ADDCOMMISSIONTREE: "/add-commission-settings/tree",
  ALLCOMMISSIONTREES: "/all/commission-setup-list/tree",
  UPDATECOMMISSIONTREE: "/update-commission-settings/tree",
};

export const IBREQUEST__API = {
  ALLPENDINGIBREQUEST: "/all-pending-ib-request",
  ALLREJECTEDIBREQUEST: "/all-rejected-ib-request",
  LATESTIBREQUEST: "/lataest-pending-ib-request",
  UPDATEIBREQ: "/update-ib-request",
  TOPIBDETAILS: "/top-rated-ibs",
  TOPIBDETAILSFILTER: "/top-rated-ibs/filter-options",
  ALLTOPPERFORMEDIB: "/top-rated-ibs/download-csv",
};

export const LOTCHART__API = {
  TRADINGLOTCHART: "/trading-lots/chart-data",
};

export const PARTNERLIST__API = {
  PARTNERLIST: "/partner-lists",
  ALLPARTNERLIST: "/all-partner-lists",
  DASHBOARDPARTNERLISTS: "/dashboard-partner-lists",
  DASHBOARDIBREQUEST: "/dashboard-ib-request",
  CLIENTTREE: "/partner-details/client-tree",
  PARTNERSUMMARY: "/partner-details/summary",
  COMMISSIONHISTORY: "/partner-details/commission-history",
  WITHDRAWALS: "/partner-details/withdrawals",
  ADVANCEDRATES: "/partner-details/commission-setup-list/tree",
  ADVANCEDRATESCOMMISSIONTREE: "/partner-details/view-commission-rates/tree",
  UPDATECOMMISSIONRATES: "/partner-details/update-commission-rates/tree",
  UPDATECOMMISSIONSTATUS: "/update-commission-status",
  ADDCLIENTLEVELONE: "/add-client-level-one",
  IBWITHDRAWAL: "/add-partner-withdraw",
};

export const DASHBOARDAPIREQ__API = {
  TOTALPARTNERS: "/get-dashboard-total-partners",
  TOTALLIVEACCOUNTS: "/dashboard-total-live-trading-accounts",
};

export const ASSIGNACCTYPE__API = {
  ALLMASTERIB: "/all-master-ib",
  MASTERIBDATATABLE: "/master-ib-list",
  UNIQUECOUNTRIES: "/unique-countries",
  ASSIGNACCTYPE: "/assign-account-types",
  ASSIGNSINGLEIB: "/assign-account-types-singleib",
};

export const LEVELUNLOCKSETTINGS__API = {
  PARTNERLEVELUNLOCKSETTINGS: "/partner-details/current-level-unlock-settings",
  LEVELUNLOCKSETTINGS: "/current-level-unlock-settings",
  POSTLEVELUNLOCKSETTINGS: "/level-unlock-settings",
  POSTPARTNERLEVELUNLOCKSETTINGS: "/partner-details/level-unlock-settings",
};

export const TRADABLEBONUS__API = {
  TRADABLEBONUSHISTORY: "/tradable-bonus-history",
  DIRECTPROVIDETRADABLEBONUS: "/direct-provide-tradable-bonus",
};

export const MAMWALLET__API = {
  MANAGERSCOMMISSIONHISTORY: "/manager-commission-history",
  WALLETTRX: "/wallet-transactions-history",
  UPDATEWALLETWITHDRAW: "/update-wallet-withdraw-request",
  MANAGERSWALLETINFO: "/managers-wallet-info",
  INVESTORSWALLETINFO: "/investors-wallet-info",
  CREATEMAMWALLETWITHDRAW: "/create-mam-wallet-withdraw",
  CREATEMAMWALLETINTX: "/create-mam-wallet-intx",
};
